const captures = new Map<string, () => HTMLCanvasElement>();
let nextId = 0;
export function registerBoardCapture(canvas: HTMLCanvasElement, capture: () => HTMLCanvasElement) {
  const id = `board-${++nextId}`; canvas.dataset.boardCapture = id; captures.set(id, capture);
  return () => { captures.delete(id); delete canvas.dataset.boardCapture; };
}
/** Freeze only currently displayed filtered canvases, synchronously before the issue editor or DOM clone. */
export function freezeBoardCaptures(): Map<string, string> {
  const result = new Map<string, string>();
  for (const [id, capture] of captures) result.set(id, capture().toDataURL('image/png'));
  return result;
}
